import AmenitiesAndServices from './AmenitiesAndServices';

export default AmenitiesAndServices;